import classes from './styles.module.scss';

function DashboardMainSectionWrapper({ children, styles = {} }) {
  return (
    <div
      className={classes.dashboard_main_section_wrapper}
      style={{ ...styles }}
    >
      {children}
    </div>
  );
}

export default DashboardMainSectionWrapper;
